// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-a688e724] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.item-list__entry[data-v-a688e724] {
  display: flex;
  align-items: flex-start;
  position: relative;
  padding: 8px;
}
.item-list__entry[data-v-a688e724]:hover, .item-list__entry[data-v-a688e724]:focus {
  background-color: var(--color-background-hover);
  border-radius: var(--border-radius-large);
}
.item-list__entry .item-avatar[data-v-a688e724] {
  position: relative;
  margin-top: auto;
  margin-bottom: auto;
}
.item-list__entry .item__details[data-v-a688e724] {
  padding-left: 8px;
  max-height: 44px;
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 44px;
}
.item-list__entry .item__details h3[data-v-a688e724],
.item-list__entry .item__details .message[data-v-a688e724] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-list__entry .item__details .message span[data-v-a688e724] {
  width: 10px;
  display: inline-block;
  margin-bottom: -3px;
}
.item-list__entry .item__details h3[data-v-a688e724] {
  font-size: 100%;
  margin: 0;
}
.item-list__entry .item__details .message[data-v-a688e724] {
  width: 100%;
  color: var(--color-text-maxcontrast);
}
.item-list__entry .item-icon[data-v-a688e724] {
  position: relative;
  width: 14px;
  height: 14px;
  margin: 27px -3px 0px -7px;
}
.item-list__entry button.primary[data-v-a688e724] {
  padding: 21px;
  margin: 0;
}

/*
.content-popover {
	height: 0px;
	width: 0px;
	margin-left: auto;
	margin-right: auto;
}
.popover-container {
	width: 100%;
	height: 0px;
}
*/`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcDashboardWidgetItem-BevETFRF.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+CAA+C;EAC/C,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;;;;;;CAWC","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-a688e724] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.item-list__entry[data-v-a688e724] {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n  padding: 8px;\n}\n.item-list__entry[data-v-a688e724]:hover, .item-list__entry[data-v-a688e724]:focus {\n  background-color: var(--color-background-hover);\n  border-radius: var(--border-radius-large);\n}\n.item-list__entry .item-avatar[data-v-a688e724] {\n  position: relative;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.item-list__entry .item__details[data-v-a688e724] {\n  padding-left: 8px;\n  max-height: 44px;\n  flex-grow: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 44px;\n}\n.item-list__entry .item__details h3[data-v-a688e724],\n.item-list__entry .item__details .message[data-v-a688e724] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.item-list__entry .item__details .message span[data-v-a688e724] {\n  width: 10px;\n  display: inline-block;\n  margin-bottom: -3px;\n}\n.item-list__entry .item__details h3[data-v-a688e724] {\n  font-size: 100%;\n  margin: 0;\n}\n.item-list__entry .item__details .message[data-v-a688e724] {\n  width: 100%;\n  color: var(--color-text-maxcontrast);\n}\n.item-list__entry .item-icon[data-v-a688e724] {\n  position: relative;\n  width: 14px;\n  height: 14px;\n  margin: 27px -3px 0px -7px;\n}\n.item-list__entry button.primary[data-v-a688e724] {\n  padding: 21px;\n  margin: 0;\n}\n\n/*\n.content-popover {\n\theight: 0px;\n\twidth: 0px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n.popover-container {\n\twidth: 100%;\n\theight: 0px;\n}\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
